export { default } from './UserReferralTable';



// WEBPACK FOOTER //
// ./src/components/UserReferral/UserReferralTable/index.js